import Tooltip from 'bootstrap/js/dist/tooltip.js'
import htmx from 'htmx.org'

// runs on initial page load and each swap action
htmx.onLoad((content) => {
  const elements = content.querySelectorAll('[data-bs-toggle="tooltip"]')

  elements.forEach((element) => {
    if (!Tooltip.getInstance(element)) {
      new Tooltip(element, { trigger: 'hover' })
    }
  })
})

// cleanup tooltips that might belong to elements about to be swapped out
document.addEventListener('htmx:beforeCleanupElement', (event) => {
  const target = event.target

  if (target instanceof Element) {
    const elementsWithTooltip = target.matches('[data-bs-toggle="tooltip"]')
      ? [target, ...target.querySelectorAll('[data-bs-toggle="tooltip"]')]
      : target.querySelectorAll('[data-bs-toggle="tooltip"]')

    elementsWithTooltip.forEach((element) => {
      const instance = Tooltip.getInstance(element)

      if (instance) {
        instance.dispose()
      }
    })
  }
})
